import React, { Fragment } from 'react'
import { Actions } from './style'
import Division from '../Division'

export default ({ children }) => (
    <Fragment>
        <Division/>
        <Actions>{children}</Actions>
    </Fragment>
)
